// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"Arrow_Arrow__3hdHD","ArrowButton":"Arrow_ArrowButton__1Ehgv","Right":"Arrow_Right__rZgs2","Left":"Arrow_Left__1MCkV","Up":"Arrow_Up__21seX","Down":"Arrow_Down__s6jBF"};